// Exterior color image imports
import AlpineWhite from '../../assets/images/colors/exterior/Alpine_White.jfif';
import ArcticRaceBlue from '../../assets/images/colors/exterior/Arctic_Race_Blue_metallic.jfif';
import BlackSapphire from '../../assets/images/colors/exterior/Black_Sapphire_Metallic.jfif';
import BrassMetallic from '../../assets/images/colors/exterior/Brass_Metallic.jfif';
import BrooklynGrey from '../../assets/images/colors/exterior/Brooklyn_Grey_Metallic.jfif';
import DarkGraphite from '../../assets/images/colors/exterior/Dark_Graphite_Metallic.jfif';
import DaytonaViolet from '../../assets/images/colors/exterior/Daytona_Violet_Metallic.jfif';
import DeepSeaGreen from '../../assets/images/colors/exterior/Deep_Sea_Green_Metallic.jfif';
import DuneGrey from '../../assets/images/colors/exterior/Dune_Grey_Metallic.jfif';
import FrozenDeepGrey from '../../assets/images/colors/exterior/Frozen_Deep_Grey .jfif';
import FrozenPureGrey from '../../assets/images/colors/exterior/Frozen_Pure_Grey_Metallic .jfif';
import MelbourneRed from '../../assets/images/colors/exterior/Melbourne_Red_Metallic.jfif';
import MineralWhite from '../../assets/images/colors/exterior/Mineral_White_Metallic.jfif';
import SantorinBlue from '../../assets/images/colors/exterior/Santorin_Blue_II.jfif';
import SkyscraperGrey from '../../assets/images/colors/exterior/Skyscraper_Grey_Metallic.jfif';
import TanzaniteBlue from '../../assets/images/colors/exterior/Tanzanite_Blue_II_Metallic.jfif';
import VegasRed from '../../assets/images/colors/exterior/Vegas_Red_Metallic.jfif';

// Interior color image imports
import BlackPerforated from '../../assets/images/colors/interior/Black_Perforated_and_Quilted.jfif';
import CalmBeige from '../../assets/images/colors/interior/Calm_Beige_Perforated_and_Quilted.jfif';
import EspressoBrown from '../../assets/images/colors/interior/Espresso_Brown_Perforated_and_Quilted.jfif';

// Node name constants for different car types
// NOTE: Both trims now use BMW.glb with BASE_PARTS (Classic) / PRO_PARTS (M Sport) toggling
const EXT_CLASSIC = "EXT_CLASSIC"; // Classic BMW Design exterior (child of BASE_PARTS)
const EXT_MSPORT = "EXT_MSPORT"; // M Sport exterior (child of PRO_PARTS)
const INT_CLASSIC = "INT_CLASSIC"; // Classic BMW Design interior (child of BASE_PARTS)
const INT_MSPORT = "INT_MSPORT"; // M Sport interior (child of PRO_PARTS)
const WHEELS_CLASSIC = "WHEELS_CLASSIC"; // Classic wheels (child of BASE_PARTS)
const WHEELS_MSPORT = "WHEELS_MSPORT"; // M Sport wheels (child of PRO_PARTS)
const HEADLIGHTS_CLASSIC = "HEADLIGHTS_CLASSIC"; // Classic headlights (child of BASE_PARTS)
const HEADLIGHTS_MSPORT = "HEADLIGHTS_MSPORT"; // M Sport headlights (child of PRO_PARTS)

// Trim node visibility constants
const BASE_PARTS = "BASE_PARTS"; // Classic BMW Design parts container
const PRO_PARTS = "PRO_PARTS"; // M Sport parts container

const bmwX3Data = {
    // Model: Classic BMW Design
    "Classic BMW Design": {
        headLightTexture: [],
        hotspotDescription: {
            interior: {
                "Front Seats": {
                    title: "CRAFTED FOR COMFORT",
                    description: "Heated, power-adjustable seats with memory settings and lumbar support",
                    hotspotPosition: { x: 0.8, y: 0.6, z: -0.2 },
                    cameraTarget: { x: 0.9, y: 0.7, z: -0.3 }
                },
                "Rear Space": {
                    title: "SPACE TO STRETCH",
                    description: "Plenty of room for exceptional rear seating comfort",
                    inInteractionCopy: ["36.3 inches"],
                    hotspotPosition: { x: 2.2, y: 0.4, z: -0.3 },
                    cameraTarget: { x: 0.6, y: 0.6, z: -1.1 }
                },
                "Trunk Cargo": {
                    title: "CARGO CAPABLE",
                    description: "Up to 67 cubic feet of storage space with rear seats folded flat",
                    hotspotPosition: { x: 0.0, y: 0.4, z: -1.8 },
                    cameraTarget: { x: 0.1, y: 0.5, z: -1.9 }
                },
                "BMW Interaction Bar": {
                    title: "CONTROL AT YOUR FINGERTIPS",
                    description: "Responsive BMW Interaction Bar glows in 15 colors, changing based on your chosen mode",
                    hotspotPosition: { x: 1.35, y: 0.45, z: -0.55 },
                    cameraTarget: { x: 1.45, y: 0.55, z: -0.65 }
                },
                "Tech Suite": {
                    title: "TECH FOCUSED",
                    description: "Choose your My Mode to customize—options include Personal, Sport, Efficient, Expressive, Relax, or Digital Art",
                    hotspotPosition: { x: 1.25, y: 0.55, z: -0.35 },
                    cameraTarget: { x: 1.35, y: 0.65, z: -0.45 }
                }
            },
            exterior: {
                "LED Headlights": {
                    title: "LIGHT THE WAY",
                    description: "Sleek LED headlights and the iconic glow grille maximize clarity day or night",
                    hotspotPosition: { x: -0.75, y: 1.25, z: 2.35 },
                    cameraTarget: { x: -0.65, y: 1.35, z: 2.45 }
                },
                "Modern Design": {
                    title: "SOPHISTICATED TOUCH",
                    description: "A modern exterior features bold angles and sleek finishes",
                    inInteractionCopy: ["Sharp, defined contours", "Flared wheel arches", "Elegant satin aluminum trim"],
                    hotspotPosition: { x: -1.2, y: 1.0, z: 0.5 },
                    cameraTarget: { x: -1.1, y: 1.1, z: 0.6 }
                },
                "19\" Wheels": {
                    title: "CRAFTED TO PERFORM",
                    description: "All-wheel drive and advanced braking capabilities mean better control under any conditions",
                    inInteractionCopy: ["BMW Brake Drying System", "Brake Standby", "Automatic Hold"],
                    hotspotPosition: { x: -1.5, y: 0.4, z: 0.0 },
                    cameraTarget: { x: -1.4, y: 0.5, z: 0.1 }
                },
                "Flush Door Handles": {
                    title: "CLEAN LINES",
                    description: "Fully flush door handles for aerodynamic efficiency",
                    hotspotPosition: { x: -1.8, y: 0.8, z: 0.2 },
                    cameraTarget: { x: -1.7, y: 0.9, z: 0.3 }
                },
                "LED Taillights": {
                    title: "DRAMATIC EXIT",
                    description: "T-shaped LED taillights leave a lasting impression",
                    hotspotPosition: { x: 0.1, y: 0.65, z: -2.05 },
                    cameraTarget: { x: 0.2, y: 0.75, z: -2.15 }
                }
            },
        },
        visibleNodes: [EXT_CLASSIC, INT_CLASSIC, WHEELS_CLASSIC, HEADLIGHTS_CLASSIC],
        invisibleNodes: [EXT_MSPORT, INT_MSPORT, WHEELS_MSPORT, HEADLIGHTS_MSPORT],
        Exterior: {
            material: {
                color: [
                    { name: 'Alpine White', colorCode: '#ffffff', metalness: 0.4, imagePath: AlpineWhite },
                    { name: 'Arctic Race Blue Metallic', colorCode: '#4E7088', metalness: 0.8, imagePath: ArcticRaceBlue },
                    { name: 'Black Sapphire Metallic', colorCode: '#404040', metalness: 0.8, imagePath: BlackSapphire },
                    { name: 'Dark Graphite Metallic', colorCode: '#4A4A4A', metalness: 0.8, imagePath: DarkGraphite },
                    { name: 'Mineral White Metallic', colorCode: '#FFFFFF', metalness: 0.7, imagePath: MineralWhite },
                    { name: 'Skyscraper Grey Metallic', colorCode: '#8E8F8F', metalness: 0.8, imagePath: SkyscraperGrey },
                    { name: 'Vegas Red Metallic', colorCode: '#cd3234', metalness: 0.6, imagePath: VegasRed },
                    { name: 'DuneGrey Metallic', colorCode: '#e9e4d7', metalness: 0.5, imagePath: DuneGrey },
                ],
                roughness: 0.3,
                metalness: 0.9,
            },
        },
        Interior: {
            material: {
                black: {
                    name: 'Black Perforated and Quilted',
                    imagePath: BlackPerforated,
                    roughness: 0.4,
                    metalness: 0.1,
                },
                beige: {
                    name: 'Calm Beige Perforated and Quilted',
                    imagePath: CalmBeige,
                    roughness: 0.4,
                    metalness: 0.1,
                },
                brown: {
                    name: 'Espresso Brown Perforated and Quilted',
                    imagePath: EspressoBrown,
                    roughness: 0.4,
                    metalness: 0.1,
                },
            },
        },
    },

    // Model: M Sport - Motorsport Form
    "M Sport - Motorsport Form": {
        headLightTexture: [],
        hotspotDescription: {
            interior: {
                "Tech Suite": {
                    title: "TECH FOCUSED",
                    description: "Choose your My Mode to customize—options include Personal, Sport, Efficient, Expressive, Relax, or Digital Art",
                    hotspotPosition: { x: 1.35, y: 0.65, z: -0.45 },
                    cameraTarget: { x: 1.45, y: 0.75, z: -0.55 }
                },
                "M Steering Wheel": {
                    title: "MOTORSPORT DNA",
                    description: "M Sport features are integrated throughout design and performance, including a ten second Sport Boost",
                    inInteractionCopy: ["Sport Boost for maximum power", "M Paddle Shifter", "Perforated Grip & Stitching"],
                    hotspotPosition: { x: 1.15, y: 0.85, z: -0.35 },
                    cameraTarget: { x: 1.25, y: 0.95, z: -0.45 }
                },
                "BMW Interaction Bar": {
                    title: "CONTROL AT YOUR FINGERTIPS",
                    description: "Responsive BMW Interaction Bar glows in 15 colors, changing based on your chosen mode",
                    hotspotPosition: { x: 1.45, y: 0.55, z: -0.65 },
                    cameraTarget: { x: 1.55, y: 0.65, z: -0.75 }
                },
                "Front Seats": {
                    title: "TAILORED COMFORT",
                    description: "Experience heated, power-adjustable seats with memory settings and lumbar support",
                    hotspotPosition: { x: 0.9, y: 0.7, z: -0.3 },
                    cameraTarget: { x: 1.0, y: 0.8, z: -0.4 }
                },
                "Trunk Cargo": {
                    title: "CARGO CAPABLE",
                    description: "Up to 67 cubic feet of storage space with rear seats folded flat",
                    hotspotPosition: { x: 0.0, y: 0.4, z: -1.8 },
                    cameraTarget: { x: 0.1, y: 0.5, z: -1.9 }
                }
            },
            exterior: {
                "M Sport Brakes": {
                    title: "POWER MEETS PRECISION",
                    description: "See M Sport Brakes with Red or Blue calipers work from the outside",
                    hotspotPosition: { x: -1.5, y: 0.4, z: 0.0 },
                    cameraTarget: { x: -1.4, y: 0.5, z: 0.1 }
                },
                "LED Headlights": {
                    title: "SIGNATURE IN LIGHT",
                    description: "The Iconic Glow kidney grille emits a white LED halo, giving the X3 a distinctive nighttime identity",
                    hotspotPosition: { x: 0.2, y: 1.15, z: 2.15 },
                    cameraTarget: { x: 0.3, y: 1.25, z: 2.25 }
                },
                "Trim": {
                    title: "DRAMATIC FRAMING",
                    description: "Shadowline exterior trim frames the X3 in high-gloss black",
                    inInteractionCopy: ["High-gloss black roof rails", "High-gloss black window surrounds", "M Shadowline Lights", "Extended Shadowline Trim"],
                    hotspotPosition: { x: -1.2, y: 1.0, z: 0.5 },
                    cameraTarget: { x: -1.1, y: 1.1, z: 0.6 }
                },
                "Sculpted Strength": {
                    title: "SCULPTED STRENGTH",
                    description: "Bold, athletic lines create a striking and modern look from every angle",
                    inInteractionCopy: ["Sporty rear diffuser", "Aerodynamic air curtains", "Sleek, flush door handles"],
                    hotspotPosition: { x: -1.3, y: 0.8, z: 0.3 },
                    cameraTarget: { x: -1.2, y: 0.9, z: 0.4 }
                },
                "19\" Wheels": {
                    title: "ENGINEERED FOR EXPRESSION",
                    description: "19\" M wheels design creates a perfect balance of bold styling and performance",
                    inInteractionCopy: ["Adaptive M Suspension", "M Sport Brakes"],
                    hotspotPosition: { x: -1.5, y: 0.4, z: 0.0 },
                    cameraTarget: { x: -1.4, y: 0.5, z: 0.1 }
                }
            },
        },
        visibleNodes: [EXT_MSPORT, INT_MSPORT, WHEELS_MSPORT, HEADLIGHTS_MSPORT],
        invisibleNodes: [EXT_CLASSIC, INT_CLASSIC, WHEELS_CLASSIC, HEADLIGHTS_CLASSIC],
        Exterior: {
            material: {
                color: [
                    { name: 'Alpine White', colorCode: '#ffffff', metalness: 0.4, imagePath: AlpineWhite },
                    { name: 'Black Sapphire Metallic', colorCode: '#404040', metalness: 0.8, imagePath: BlackSapphire },
                    { name: 'Brooklyn Grey Metallic', colorCode: '#bec4c6', metalness: 0.8, imagePath: BrooklynGrey },
                    { name: 'Mineral White Metallic', colorCode: '#FFFFFF', metalness: 0.7, imagePath: MineralWhite },
                    { name: 'Dark Graphite Metallic', colorCode: '#4A4A4A', metalness: 0.8, imagePath: DarkGraphite },
                    { name: 'Vegas Red Metallic', colorCode: '#cd3234', metalness: 0.6, imagePath: VegasRed },
                    { name: 'Arctic Race Blue Metallic', colorCode: '#4E7088', metalness: 0.8, imagePath: ArcticRaceBlue },
                    { name: 'DuneGrey Metallic', colorCode: '#e9e4d7', metalness: 0.5, imagePath: DuneGrey },
                ],
                roughness: 0.3,
                metalness: 0.9,
            },
        },
        Interior: {
            material: {
                black: {
                    name: 'Black Perforated and Quilted',
                    imagePath: BlackPerforated,
                    roughness: 0.4,
                    metalness: 0.1,
                },
                beige: {
                    name: 'Calm Beige Perforated and Quilted',
                    imagePath: CalmBeige,
                    roughness: 0.4,
                    metalness: 0.1,
                },
                brown: {
                    name: 'Espresso Brown Perforated and Quilted',
                    imagePath: EspressoBrown,
                    roughness: 0.4,
                    metalness: 0.1,
                },
            },
        },
    },
};

// Export the constants for use in other files
export {
    bmwX3Data,
    EXT_CLASSIC,
    EXT_MSPORT,
    INT_CLASSIC,
    INT_MSPORT,
    WHEELS_CLASSIC,
    WHEELS_MSPORT,
    HEADLIGHTS_CLASSIC,
    HEADLIGHTS_MSPORT
};

export default bmwX3Data;